<template>
  <div>
    <!-- <hr /> -->
    <!-- action {{ action }} <br />
    stationSetupID {{ stationSetupID }} <br />
    sensorSetupID {{ sensorSetupID }} <br /> -->

    <div class="columns">
      <div class="column is-1"></div>

      <!-- CREATE -->
      <div class="column is-11" v-if="action == 'create'">
        <o-field label="Sensor setup title" message="*required" variant="">
          <o-input v-model="formData.dct_title"></o-input>
        </o-field>

        <o-field
          label="Sensor setup description"
          message="*required"
          variant=""
        >
          <o-input v-model="formData.dct_description"></o-input>
        </o-field>

        <hr />

        <div class="columns">
          <div class="column is-1"></div>
          <div class="column">
            <o-button
              icon-left="plus"
              variant="primary"
              iconPack="fa"
              @click.prevent="createObject"
            >
              Create a new sensor setup
            </o-button>
          </div>
          <div class="column">
            <o-button
              icon-left="ban"
              variant="warning"
              iconPack="fa"
              @click.prevent="$emit('cancelCreation')"
            >
              Cancel
            </o-button>
          </div>

          <div class="column is-1"></div>
        </div>
      </div>

      <!-- stationSetupView -->
      <div class="column is-11" v-if="action == 'stationSetupView'">
        <div class="content">
          <p><b>Sensor Setup title: </b> {{ formData.dct_title }}</p>

          <p>
            <b>Sensor Setup description: </b> {{ formData.dct_description }}
          </p>

          <b>
            <router-link :to="/sensorsetup/ + sensorSetupID">
              <a>Click here for more</a></router-link
            ></b
          >
        </div>
      </div>

      <!-- Editing mode -->
      <div class="column is-11" v-if="action == 'edit'">
        <o-field label="Sensor setup title" message="*required" variant="">
          <o-input v-model="formData.dct_title"></o-input>
        </o-field>

        <o-field label="Setup description" message="*required" variant="">
          <o-input v-model="formData.dct_description"></o-input>
        </o-field>

        <!-- Buttons -->
        <div class="columns">
          <div class="column is-1"></div>
          <div class="column">
            <o-button
              icon-left="plus"
              variant="primary"
              iconPack="fa"
              @click.prevent="updateCordraObject"
            >
              Update sensor setup
            </o-button>
          </div>
          <div class="column">
            <o-button
              icon-left="ban"
              variant="warning"
              iconPack="fa"
              @click.prevent="stepBack"
            >
              Cancel
            </o-button>
          </div>
          <hr />

          <div class="column is-1"></div>
        </div>

        <!-- Sensors -->
        <o-field label="Sensor:">
          <div class="block" v-if="formData.ods_hasSensor">
            <Sensor
              :action="'sensorSetupView'"
              :sensorSetupID="sensorSetupID"
              :sensorID="formData.ods_hasSensor"
            />
          </div>
          <div v-else>There is no sensor defined</div>
        </o-field>

        <!-- Create a new sensor here -->
        <section style="width: 100%" v-if="sensorNewOne == true">
          <div class="box">
            <Sensor :action="'create'" :sensorSetupID="sensorSetupID" />
          </div>
        </section>

        <o-button
          icon-left="plus"
          variant="primary"
          iconPack="fa"
          @click.prevent="sensorNewOne = !sensorNewOne"
          v-if="sensorNewOne == false"
        >
          Add new sensor</o-button
        ><br />
        <br />
      </div>

      <hr />
    </div>
  </div>
</template>

<script setup>
import Sensor from "@/components/forms/SensorForm.vue";
import Map from "@/components/Map.vue";
</script>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

import CordraMixin from "@/mixins/cordra";
import CamAndCaptureMixin from "@/mixins/camAndCapture";

export default {
  name: "SensorSetupForm",

  mixins: [CordraMixin, CamAndCaptureMixin],
  emits: ["cancelCreation", "reloadProject"],
  props: [
    "action" /* action is 'create', 'edit' or 'stationSetupView' */,
    "stationSetupID",
    "sensorSetupID",
  ],

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      showMap: false,

      formData: {
        singleObjOwnership: false,

        dct_title: "",
        dct_description: "",
        ods_hasSensor: null,
      },

      sensorNewOne: false,
    };
  },

  methods: {
    ...mapMutations({ newMessage: "messenger/newMessage" }),

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    restoreData() {
      console.group("restoreData", this.cordraSearchResult);
      this.formData.singleObjOwnership = this.cordraSearchResult[1];

      // Modell
      this.formData.dct_title = this.cordraSearchResult[0].content["name"];
      this.formData.dct_description =
        this.cordraSearchResult[0].content["description"];
      this.formData.ods_hasSensor =
        this.cordraSearchResult[0].content["hasSensor"];

      // Schema
      this.formData.ods_inStationSetup =
        this.cordraSearchResult[0].content["inStationSetup"];

      this.formData.context = this.cordraSearchResult[0].content["@context"];

      // Trigger
      this.showMap = true;
      // console.log("Show Map");

      console.log("this.formData:", this.formData);
      console.groupEnd();
    },

    async createObject() {
      // console.group("createObject()");
      var error = this.validateForm();
      if (error) {
        return false;
      }

      let cordraLayoutObject = {
        type: process.env.VUE_APP_CORDRA_DATATYPE_SENSORSETUP,
        content: {
          name: this.formData.dct_title,
          description: this.formData.dct_description,
          inStationSetup: this.stationSetupID,
        },
      };
      // console.log("Sensor Setup cordraLayoutObject", cordraLayoutObject);

      this.stepBack(await this.cordraCreateDocument(cordraLayoutObject));

      // console.groupEnd();
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async updateCordraObject() {
      var error = this.validateForm();
      if (error) {
        return false;
      }
      let cordraObject = {
        id: this.sensorSetupID,
        content: {
          id: this.sensorSetupID,
          name: this.formData.dct_title,
          description: this.formData.dct_description,
          inStationSetup: this.formData.ods_inStationSetup,
          hasSensor: this.formData.ods_hasSensor,
        },
      };
      this.stepBack(await this.cordraUpdateDocument(cordraObject));
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    validateForm() {
      // TODO: write proper a validation

      var error = false;
      var createError = (msg) => {
        let message = {
          content: "An error has occurred: " + msg,
          kind: "danger",
        };
        this.newMessage(message);
      };
      if (this.formData.dct_title === "") {
        error = true;
        createError("Please insert a title for that camera trap.");
      } else if (this.formData.dct_title.length < 3) {
        error = true;
        createError(
          "Please insert a title for that camera trap and use minimum 3 characters."
        );
      }
      if (this.formData.dct_description === "") {
        error = true;
        createError("Please insert a title for that camera trap.");
      } else if (this.formData.dct_description.length < 3) {
        error = true;
        createError(
          "Please insert a title for that camera trap and use minimum 3 characters."
        );
      }
      return error;
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stepBack(resultFlag = {}) {
      // TODO: check resultFlag error cases
      // console.group("stepBack, resultFlag:", resultFlag);

      if (resultFlag === false) {
        console.warn("error in stepBack()");
      } else if (this.action === "create") {
        this.$router.push(`/stationsetup/${this.stationSetupID}`);
      } else if (this.action === "edit") {
        this.$router.push(`/sensorsetup/${this.sensorSetupID}`);
      }

      console.groupEnd();
    },

    setCoordinates(lat, lng) {
      // console.group("setCoordinates", lat, lng);

      this.formData.dwc_decimalLatitude = lat;
      this.formData.dwc_decimalLongitude = lng;

      // console.groupEnd();
    },
  },

  computed: {
    ...mapGetters({
      keycloakGetStatusReady: "keycloak/getStatusReady",
      keycloakGetStatusAuthenticated: "keycloak/getStatusAuthenticated",
    }),

    markerObjects() {
      return [
        {
          lat: this.formData.dwc_decimalLatitude,
          lng: this.formData.dwc_decimalLongitude,
        },
      ];
    },
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  created() {
    // console.group("created");
    // console.log("this.action", this.action);
    // console.log("this.sensorSetupView", this.sensorSetupID);

    if (this.action === "edit" || this.action === "stationSetupView") {
      this.cordraGetDocumentAndOwnership(this.sensorSetupID);
    }

    // console.groupEnd();
  },
};
</script>
